<template>
    <div class="form-submission-card">
		<div class="form-submission-card">
			<div class="form-submission-card-content">
				<div class="row">
					<div class="col-xl-6 pt-3">
						<!--Satisfactory-->
						<div class="item mb-4">
							<div
								class="form-submission-card-bar"
								:style="{
									'background-color': getStatementColour(2),
									'width': (parseInt(((getAmounts()[2] / totalAmount) * 100)) || 1) + '%'
								}"
							></div>
							<h6 class="form-submission-card-bar-label" :style="'color: ' + getStatementColour(2)">
								Satisfactory
							</h6>
							<h6 class="form-submission-card-bar-label" :style="'color: ' + getStatementColour(2)">
								{{ parseInt((getAmounts()[2] / totalAmount) * 100) || 0 }}% ({{getAmounts()[2] + ' of ' + totalAmount}})
							</h6>
						</div>

						<!--Non Compliance-->
						<div class="item mb-4" :style="'color: ' + getStatementColour(1)">
							<div
								class="form-submission-card-bar"
								:style="{
									'background-color': getStatementColour(1),
									'width': (parseInt(((getAmounts()[1] / totalAmount) * 100)) || 1) + '%'
								}"
							></div>
							<h6 class="form-submission-card-bar-label" :style="'color: ' + getStatementColour(1)">
								Non Compliance
							</h6>
							<h6 class="form-submission-card-bar-label" :style="'color: ' + getStatementColour(1)">
								{{ parseInt((getAmounts()[1] / totalAmount) * 100) || 0 }}% ({{getAmounts()[1] + ' of ' + totalAmount}})
							</h6>
						</div>

						<!--Major Non Compliance-->
						<div class="item" :style="'color: ' + getStatementColour(0)">
							<div
								class="form-submission-card-bar"
								:style="{
									'background-color': getStatementColour(0),
									'width': (parseInt(((getAmounts()[0] / totalAmount) * 100)) || 1) + '%'
								}"
							></div>
							<h6 class="form-submission-card-bar-label" :style="'color: ' + getStatementColour(0)">
								Major Non Compliance
							</h6>
							<h6 class="form-submission-card-bar-label" :style="'color: ' + getStatementColour(0)">
								{{ parseInt((getAmounts()[0] / totalAmount) * 100) || 0 }}% ({{getAmounts()[0] + ' of ' + totalAmount}})
							</h6>
						</div>
					</div>
					<div v-if="totalAmount" class="col-xl-6 d-xl-flex justify-content-xl-end">
						<div class="" style="max-width: 400px;">
							<canvas id="myChart" width="400" height="400"></canvas>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-4" id="accordion">
			<collapsable
				accordion="#accordion"
				v-for="(category_submission, index) in form_submission.site_survey_inspection_category_submissions"
				:key="category_submission.id"
				:title="category_submission.category.title"
				:show="index === 0"
				:no_table_line="true"
				v-if="categoryHasAnyResult(category_submission)"
			>
				<template slot="content">

					<div
						v-for="statement in category_submission.statements"
						:key="statement.id"
						v-show="statement.result !== null"
					>
						<div class="d-flex justify-content-between border-bottom mt-4 pb-3 px-2">
							<h5 class="">{{statement.category_statement.title}}</h5>
							<svg-image
								:src="'/svg/' + resource_group + '/' + getStatementIcon(statement.result)"
								:color="getStatementColour(statement.result)"
							></svg-image>
						</div>

						<div class="row mt-3 px-2">
							<div class="col-6">
								<div class="text-light">Comments</div>
								<div>{{statement.answer}}</div>
							</div>

							<div class="col-6">
								<div class="text-light">Action For</div>
								<div>{{statement.action}}</div>
							</div>

							<div class="col-12 mt-3">
								<gallery-view-component
									title="Images"
									:photos="statement.images"
								></gallery-view-component>
							</div>
						</div>
					</div>

				</template>
			</collapsable>

			<div class="form-submission-card" v-if="!totalAmount">
				<h5 class="px-2">No statements submitted</h5>
			</div>
		</div>
    </div>
</template>

<script>
    import GalleryViewComponent from "../general_components/GalleryViewComponent";
    import {getChartColors} from "../../helpers/colors";
	import Collapsable from "../ListComponent/Collapsable";
	export default {
		name: "SiteSurveyInspectionReportSubmission",
		components: {Collapsable, GalleryViewComponent},
		props: [
        	'name',
            'form_submission',
        ],

        data() {
            return {
                complianceAmounts: null
            }
        },

        mounted(){
            this.getAmounts();
            $(document).ready(() => {

                var myPieChart = new Chart($('#myChart'), {
                    type: 'pie',
                    data: {
                        labels: [
                            'Major non Compliance',
                            'Non Compliance',
                            'Satisfactory'
                        ],
                        datasets: [
                            {
                                fill: true,
                                backgroundColor: getChartColors(),
                                data: Object.values(this.getAmounts()),
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        }
                    }
                });
            });
        },

        methods: {
            getAmounts: function(){
                var amounts = {
                    0: 0,
                    1: 0,
                    2: 0
                };

                this.complianceAmounts =
                    this.complianceAmounts != null
                        ? this.complianceAmounts
                        : this.form_submission
                                .site_survey_inspection_category_submissions
                                .reduce((amounts, category_submission) => {
                                	console.log('in');
                                    return category_submission
                                                .statements
                                                .filter(function (statement){
                                                    return statement.result !== null;
                                                })
                                                .reduce(function(amounts, statement) {
                                                    amounts[statement.result] += 1;

                                                    return amounts;
                                                }, amounts);
                                }, amounts);

                return this.complianceAmounts;
            },
            getStatementColour: function(value){
                const colour = getChartColors();

                return colour[value];
            },
			getStatementIcon: function (value){
            	switch (value){
            		case 0:
            			return 'answer_incorrect.svg';
            		case 1:
            			return 'answer_adequate.svg';
            		case 2:
            			return 'answer_correct.svg';
				}
			},
			categoryHasAnyResult: function (category){
				return !!category.statements.filter((statement) => statement.result !== null).length;
			}
        },

        computed: {
            totalAmount: function(){
                return Object.values(this.getAmounts())
                             .reduce((amount, item) => {
                                return amount + item;
                             }, 0)
            },
        }
	}
</script>
